import React from 'react';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import { jsx as _jsx } from "react/jsx-runtime";
export var ExternalDomainLink = function ExternalDomainLink(_ref) {
  var children = _ref.children,
    href = _ref.href;
  if (!href) {
    return /*#__PURE__*/_jsx(Text, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(TextLink, {
    bold: true,
    rel: "noopener noreferrer",
    target: "_blank",
    href: href,
    children: children
  });
};